import { Button, Grid2 as Grid, Grid2Props, IconButton } from "@mui/material";
import React from "react";
import { useFormHandlerContext } from "../../../controllers/formController";
import { singleGridItem } from "../../forms/fields/defaultStyles";
import ArraySubFormProvider from "../../forms/fields/subForms/array/ArraySubFormProvider";
import ArraySubFormList from "../../forms/fields/subForms/array/ArraySubFormList";
import GroupGridContainer from "../../common/GroupGridContainer";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import ArraySubFormAdd from "../../forms/fields/subForms/array/ArraySubFormAdd";
import FormLabel from "../../forms/common/base/FormLabel";
import FormSelectField from "../../forms/fields/basic/SelectField";

interface RevisionListProps extends Grid2Props {
  name: string;
  useEnum: string;
  disabled?: boolean;
}

const RevisionList: React.FC<RevisionListProps> = ({
  name,
  useEnum,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();
  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <FormLabel label="Revisions" name={name} />
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(index, remove) => (
            <GroupGridContainer key={index}>
              <FormSelectField
                name="revision"
                useEnum={useEnum}
                label={`Revision ${index + 1}`}
                required
                placeholder="Select revision"
                actions={
                  <IconButton
                    color="error"
                    onClick={() => remove()}
                    disabled={isProcessing}
                  >
                    <RemoveCircleOutline />
                  </IconButton>
                }
              />
            </GroupGridContainer>
          )}
        />

        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                disabled={disabled || isProcessing}
                onClick={() => append({ revision: "" })}
              >
                Add Revision
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};

export default RevisionList;
